import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { showTokenExpiredAlert, getConfig, authHeader, getCustId, isApiSuccess, apiMessage } from "utils";

// POST subscriber/getDbcdrProcessing (server-side paging, page is 1-based)
// { createDate:"yyyy-MM-dd", endDate:"yyyy-MM-dd", custId, page:"1", pageSize:"10", sortBy:"id", sortOrder:"0" }
// No records => HTTP 200 with responseCode 406 "Record Not Found !"
export const sessionList = createAsyncThunk('sessions/list', async ({ filter, pageable, navigate }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'subscriber/getDbcdrProcessing',
            data: {
                "createDate": filter?.createDate,
                "endDate": filter?.endDate,
                "custId": getCustId(),
                "page": String(pageable?.currentPage + 1),
                "pageSize": String(pageable?.pageSize),
                "sortBy": "id",
                "sortOrder": "0",
            },
            headers: authHeader()
        })
        return res
    } catch (error) {
        return error.response
    }
})

const sessions = createSlice({
    name: 'sessions',
    initialState: {
        list: [],
        totalRecords: 0,
        message: '',
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(sessionList.pending, (state) => {
            state.loading = true;
            state.message = '';
        });
        builder.addCase(sessionList.fulfilled, (state, action) => {
            state.loading = false;
            if (isApiSuccess(action?.payload)) {
                state.list = action.payload.data.dataList || [];
                state.totalRecords = action.payload.data.totalRecords || 0;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else {
                state.list = []
                state.totalRecords = 0
                state.message = apiMessage(action?.payload)
            }
        });
        builder.addCase(sessionList.rejected, (state) => {
            state.loading = false;
        });
    }
})

export default sessions.reducer;
